import type { TableHeader } from '@shared/components/table/types';
import { getLabel } from '@shared/utils';

export const USERS_REPORT_VIEW_DEFAULT_HEADERS: TableHeader[] = [
  { id: 'user', label: getLabel('user'), isSortable: true },
  { id: 'name', label: getLabel('name'), isSortable: true },
  { id: 'profile_state', label: getLabel('profileState'), isSortable: true },
  { id: 'subsidiary', label: getLabel('subsidiary'), isSortable: true },
  { id: 'role', label: getLabel('role'), isSortable: true },
];
